<template>
  <el-dialog :title="titleTrans" :visible.sync="centerDialogVisible" @close="cancel">
    <div>
      <el-form ref="submitData" :model="submitData" label-width="120px" :rules="rules">
        <el-form-item v-if="clickType==0" label="子系统编号" prop="code">
          <el-input v-model="submitData.code" />
        </el-form-item>
        <el-form-item v-if="clickType==1" label="子系统编号">
          <span>{{ submitData.code }}</span>
        </el-form-item>
        <el-form-item label="子系统名称" prop="name">
          <el-input v-model="submitData.name" />
        </el-form-item>
        <el-form-item label="业务类别" prop="businessType">
          <el-select v-model="submitData.businessType" placeholder="请选择业务类型">
            <el-option v-for="item in businessList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="工作台显示" prop="isEnable">
          <el-radio-group v-model="submitData.isEnable">
            <el-radio label="1">显示</el-radio>
            <el-radio label="0">不显示</el-radio>
          </el-radio-group>

        </el-form-item>
        <el-form-item label="排序号" prop="sort">
          <el-input v-model="submitData.sort" />
        </el-form-item>
        <el-form-item label="logo" prop="logo">
          <el-input v-model="submitData.logo" />
        </el-form-item>
        <el-form-item label="访问地址" prop="address">
          <el-input v-model="submitData.address" />
        </el-form-item>

      </el-form>


    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel" style="margin-right:8px">取消</el-button>
      <el-button type="primary" @click="onSubmit('submitData')">确认</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import { systemDetail, getLocalDictionary, editSystem, validateCode } from '@/api/system'
  import { validateTwenty, lengthFifty, lengthTen, validateTenNumber, validateOneHundred } from '@/api/validate'
  import { statusTrans, emptyTrans } from '@/api/dataTrans.js'
  export default {
    props: ['clickType', 'editPar'],
    data() {
      return {
        submitData: {
          id: null,
          code: null,
          name: null,
          businessType: null,
          isEnable: '1',
          sort: null,
          logo: null,
          address: null
        },
        rules: {
          code: [{
            required: true,
            validator: this.checkoutCode,
            trigger: 'blur'
          }],
          name: [{
            required: true,
            validator: validateTwenty,
            trigger: 'change'
          }],
          businessType: [{
            required: true,
            message: '请选择业务类别',
            trigger: 'change'
          }],
          sort: [{
            required: true,
            validator: validateTenNumber,
            trigger: 'change'
          }],
          logo: [{
            required: true,
            validator: validateOneHundred,
            trigger: 'change'
          }],
          address: [{
            required: true,
            validator: lengthFifty,
            trigger: 'change'
          }]

        },
        businessList: [{ id: 1, "name": "业务系统" }, { id: 2, "name": "支撑系统" }, { id: 3, "name": "基础服务" }],
        id: null,
        flag: false,
        centerDialogVisible: true,
      }
    },
    computed: {
    titleTrans() {
      let result = '添加子系统'
      if (this.clickType==1) {
        result = '编辑子系统'
      }
      return result
    }
  },
    mounted() {
      // this.businessList = JSON.parse(window.localStorage.getItem('dictionary'))
      if (this.clickType == '0') {
      } else if (this.clickType == '1') {
        this.id = this.editPar
        this.submitData.id = this.editPar
        this.getSystemDetail()
      }
      console.log(this.businessList)
    },
    methods: {
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            editSystem(this.submitData).then(res => {
              if (res && res.code === 0) {
                // this.$message({
                //   message: '提交成功',
                //   type: 'success'
                // })

                this.$emit('returnResult')
              } else {
                this.$message.error(res.message)
              }
            })
          } else {
            return false
          }
        })
      },
      getSystemDetail() {
        systemDetail({ id: this.id }).then(res => {
          if (res && res.code == 0) {
            this.submitData.code = res.data.code
            this.submitData.name = res.data.name
            this.submitData.businessType = res.data.businessType

            if (res.data.isEnable) {
              this.submitData.isEnable = '1'
            } else {
              this.submitData.isEnable = '0'
            }
            this.submitData.sort = res.data.sort.toString()
            this.submitData.logo = res.data.logo
            this.submitData.address = res.data.address
          }
        })
      },
      cancel() {
        this.$emit('returnResult', {})
      },
      checkoutCode(rule, value, callback) {
        if (value) {
          validateCode({ code: this.submitData.code }).then(res => {
            if (res && res.code == 0) {
              this.flag = res.data
              if (value == '' || value == null || value == undefined) {
                callback(new Error('子系统编号不能为空'))
              } else if (value.length > 20) {
                callback(new Error('编号长度不能超过20'))
              } else if (this.flag) {
                callback(new Error('子系统编号不可以重复'))
              } else {
                callback()
              }
            }
          })
        } else {
          callback(new Error('子系统编号不能为空'))
        }
      },
      // 业务类型
      businessStatus(_val) {
        return statusTrans(_val, this.businessList)
      }

    }
  }
</script>
<style lang="scss" scoped>
  .el-radio {
    margin-right: 40px;
    width: 40px;
  }

  .el-select {
    width: 100%;
  }
</style>